import React from 'react';
import { withRouter } from 'react-router-dom';
import 'react-google-places-autocomplete/dist/index.min.css';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { Loader } from 'semantic-ui-react';

const SearchBar = (props: any) => {
    const { getSearchResultCoords } = props;

    return (
        <GooglePlacesAutocomplete
            onSelect={({ description }) => {
                getSearchResultCoords(description);
            }}
            loader={<Loader inverted />}
            placeholder="Enter an address"
            apiKey={'AIzaSyAF_YJyZHBYiW-O6Cq4Jyzj1Sthopvubfc'}
        />
    );
};

export default withRouter(SearchBar);
